module.exports = __webpack_public_path__ + "img/portraits_14_V.e12aeac9.jpg";